import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ExternalLink, Rocket, Users, HardHat, GraduationCap } from "lucide-react";

const ICON = { "Apprenticeship.gov": Rocket, "AmeriCorps": Users, "YouthBuild": HardHat, "Job Corps": GraduationCap };
const COLOR = { "Apprenticeship.gov": "bg-nh-accent", "AmeriCorps": "bg-nh-sky", "YouthBuild": "bg-nh-mint", "Job Corps": "bg-nh-pink" };

export default function YouthResources() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/resources/youth").then((r)=>setItems(r.data.resources || [])); }, []);

  return (
    <div className="nh-container py-14">
      <span className="nh-tag bg-nh-accent">Federal Programs · Free · Legit</span>
      <h1 className="font-display font-black text-4xl sm:text-5xl mt-3">Youth Resources</h1>
      <p className="text-nh-muted mt-2 max-w-2xl">Vetted federal programs where you can sign up for training, service, and career opportunities — all free.</p>

      <div className="grid md:grid-cols-2 gap-6 mt-8">
        {items.map((it) => {
          const Icon = ICON[it.name] || Rocket;
          const color = COLOR[it.name] || "bg-white";
          return (
            <div key={it.name} className="nh-card p-6" data-testid={`resource-${it.name.replace(/\W+/g,'-').toLowerCase()}`}>
              <div className={`h-14 w-14 rounded-lg border-2 border-black ${color} flex items-center justify-center`}>
                <Icon size={26}/>
              </div>
              <h2 className="font-display font-black text-2xl mt-3">{it.name}</h2>
              <p className="text-sm text-nh-muted mt-2">{it.description}</p>
              <div className="mt-3 flex items-center gap-2 text-xs">
                <span className="nh-tag bg-nh-mint">Min age {it.min_age}+</span>
              </div>
              <a href={it.url} target="_blank" rel="noreferrer" className="nh-btn nh-btn-primary mt-4 text-xs inline-flex" data-testid={`resource-visit-${it.name.replace(/\W+/g,'-').toLowerCase()}`}>
                <ExternalLink size={14}/> Visit & Sign Up
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
}
